<ng-container>
    <div [matMenuTriggerFor]="matMenu" #matMenuTrigger="matMenuTrigger" class="m-2 w-[calc(100%-16px)] relative rounded-xl cursor-pointer hover:bg-gray-200">
        <div class="w-full flex py-2 px-2" (click)="this.showDropdown = !this.showDropdown">
            <div class="w-10 h-10 rounded-full m-auto">
                <ng-container *ngIf="user?.details?.avatar; else noAvatarMain">
                    <img class="w-10 h-10 rounded-full object-cover" [src]="user?.details?.avatar">
                </ng-container>
                <ng-template #noAvatarMain>
                    <div *ngIf="user?.details?.gender !== 'female'"
                         class="w-10 h-10 rounded-full flex items-center justify-center bg-blue-100">
                        <span class="font-semibold font-inter text-[16px] text-blue-600">{{ user?.details?.fullName?.charAt(0) }}</span>
                    </div>
                    <div *ngIf="user?.details?.gender === 'female'"
                         class="w-10 h-10 rounded-full flex items-center justify-center bg-purple-100">
                        <span class="font-semibold font-inter text-[16px] text-purple-600">{{ user?.details?.fullName?.charAt(0) }}</span>
                    </div>
                </ng-template>
            </div>
            <div class="w-[calc(100%-68px)] px-2 py-2 sm:hidden lg:block">
                <span #userName id="userName" class="flex text-[14px] font-medium font-inter text-gray-900">{{ this.user?.details?.fullName?.split(' ')[0] }}</span>
            </div>
            <mat-icon class="icon-size-7 relative top-[5px]" [svgIcon]="'keyboard_arrow_down'"></mat-icon>
        </div>
    </div>
</ng-container>

<mat-menu class="pointer-events-none bg-white shadow-2xl w-[280px] left-[30px] bottom-[60px] z-99999 rounded-xl mx-[20px] my-[10px]" [overlapTrigger]="false" #matMenu="matMenu">
    <div>
        <div class="w-full">
            <div class="px-4 py-2 flex border-b border-b-gray-100">
                <div class="w-10 h-10 rounded-full my-auto">
                    <ng-container *ngIf="user?.details?.avatar; else noAvatarDropdown">
                        <img class="w-10 h-10 rounded-full object-cover" [src]="user?.details?.avatar">
                    </ng-container>
                    <ng-template #noAvatarDropdown>
                        <div *ngIf="user?.details?.gender !== 'female'"
                             class="w-10 h-10 rounded-full flex items-center justify-center bg-blue-100">
                            <span class="font-semibold font-inter text-[16px] text-blue-600">{{ user?.details?.fullName?.charAt(0) }}</span>
                        </div>
                        <div *ngIf="user?.details?.gender === 'female'"
                             class="w-10 h-10 rounded-full flex items-center justify-center bg-purple-100">
                            <span class="font-semibold font-inter text-[16px] text-purple-600">{{ user?.details?.fullName?.charAt(0) }}</span>
                        </div>
                    </ng-template>
                </div>
                <div class="w-[calc(100%-68px)] px-2 py-2">
                    <span id="userName" class="flex text-[14px] font-medium font-inter text-gray-900">{{ this.user?.details?.fullName?.split(' ')[0] + ' ' + this.user?.details?.fullName?.split(' ')[this.user?.details?.fullName?.split(' ').length - 1] }}</span>
                    <span class="flex text-[12px] font-sm font-inter text-gray-400">{{ this.user?.email }}</span>
                </div>
            </div>
        </div>
        <div class="w-full">
            <div [ngClass]="{'px-4': true, 'py-2': true, 'border-b': true, 'border-b-gray-100': true}">
                <!-- Plan Info -->
                <div *ngIf="churchData?.plan" [ngClass]="{'items-center': true, 'w-full': true, 'flex': true}">
                    <div [ngClass]="{
                        'p-1.5': true,
                        'rounded-lg': true,
                        'flex': true,
                        'items-center': true,
                        'justify-center': true,
                        'bg-orange-100': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_BRONZE,
                        'bg-gray-100': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_SILVER,
                        'bg-yellow-100': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_GOLD,
                        'bg-cyan-100': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_DIAMOND,
                        'bg-red-100': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION
                    }">
                        <mat-icon
                            [ngClass]="{
                                'icon-size-5': true,
                                'text-orange-600': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_BRONZE,
                                'text-gray-400': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_SILVER,
                                'text-yellow-500': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_GOLD,
                                'text-cyan-600': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_DIAMOND,
                                'text-red-600': churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION
                            }"
                            [svgIcon]="churchData.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION ? 'mat_outline:error_outline' : 'mat_solid:military_tech'">
                        </mat-icon>
                    </div>
                    <span [ngClass]="{'ml-2': true, 'flex': true, 'text-[14px]': true, 'font-semibold': true, 'font-inter': true, 'text-gray-900': true}">
                        {{ getPlanDisplayName(churchData.plan.name) }}
                    </span>
                </div>

                <!-- Fallback for Free Plan -->
                <div *ngIf="!churchData?.plan" [ngClass]="{'items-center': true, 'w-full': true, 'flex': true}">
                    <mat-icon [ngClass]="{'icon-size-7': true, 'relative': true}" [svgIcon]="'adjust'"></mat-icon>
                    <span [ngClass]="{'ml-2': true, 'flex': true, 'text-[14px]': true, 'font-semibold': true, 'font-inter': true, 'text-gray-600': true}">{{ MessagesConstants.BILLING_FREE_PLAN }}</span>
                </div>

                <div [ngClass]="{'w-full': true, 'mt-2': true}">
                    <span [ngClass]="{'flex': true, 'text-[12px]': true, 'font-normal': true, 'font-inter': true, 'text-gray-400': true}">
                        {{ churchData?.plan ? getPlanDescription(churchData.plan.name) : MessagesConstants.BILLING_FREE_PLAN_DESCRIPTION }}
                    </span>
                </div>
                <div *ngIf="canAccessBilling" [ngClass]="{'my-2': true, 'w-full': true}">
                    <button
                        (click)="openUpdatePlanModal(); $event.stopPropagation()"
                        [ngClass]="{'fuse-mat-button-large': true, 'rounded-[10px]': true, 'bg-[#0061ff]': true, 'border-0': true, 'w-full': true, 'pointer-events-auto': true}"
                        mat-stroked-button>
                        <mat-icon [ngClass]="{'icon-size-6': true, 'fill-white': true}"
                                  [svgIcon]="'mat_outline:update'"></mat-icon>

                        <span [ngClass]="{'ml-2': true, 'text-white': true, 'font-inter': true}">
                            {{ churchData?.plan?.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION ? 'Iniciar assinatura' : 'Atualizar plano' }}
                        </span>
                    </button>
                </div>
            </div>
            <div class="px-4 py-2 border-b border-b-gray-100">
                <div class="pointer-events-auto flex m-auto px-3 py-2 cursor-pointer text-gray-900 group hover:rounded-xl hover:bg-[#eff7ff] fuse-vertical-navigation-item-wrapper font-inter"
                     (click)="openAccountSettings(); $event.stopPropagation()">
                    <mat-icon
                        class="fuse-vertical-navigation-item-icon text-gray-900 group-hover:fill-[#0061ff]"
                        [ngClass]="'icon-size-6'"
                        [svgIcon]="'mat_outline:manage_accounts'"></mat-icon>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title">
                            <span class="ml-2 m-auto font-medium text-[14px] group-hover:text-[#0061ff]">Configurações</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="canAccessHealth" class="pointer-events-auto flex m-auto px-3 py-2 cursor-pointer text-gray-900 group hover:rounded-xl hover:bg-[#eff7ff] fuse-vertical-navigation-item-wrapper font-inter"
                     (click)="openHealthSystem(); $event.stopPropagation()">
                    <mat-icon
                        class="fuse-vertical-navigation-item-icon text-gray-900 group-hover:fill-[#0061ff]"
                        [ngClass]="'icon-size-6'"
                        [svgIcon]="'heroicons_outline:heart'"></mat-icon>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title">
                            <span class="ml-2 m-auto font-medium text-[14px] group-hover:text-[#0061ff]">Saúde do Sistema</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="canAccessBilling" class="pointer-events-auto flex m-auto px-3 py-2 cursor-pointer text-gray-900 group hover:rounded-xl hover:bg-[#eff7ff] fuse-vertical-navigation-item-wrapper font-inter"
                     (click)="openBillingModal(); $event.stopPropagation()">
                    <mat-icon
                        class="fuse-vertical-navigation-item-icon text-gray-900 group-hover:fill-[#0061ff]"
                        [ngClass]="'icon-size-6'"
                        [svgIcon]="'mat_solid:credit_card'"></mat-icon>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title">
                            <span class="ml-2 m-auto font-medium text-[14px] group-hover:text-[#0061ff]">Faturamento</span>
                        </div>
                    </div>
                </div>
                <div class="pointer-events-auto flex m-auto px-3 py-2 cursor-pointer text-gray-900 group hover:rounded-xl hover:bg-[#eff7ff] fuse-vertical-navigation-item-wrapper font-inter"
                     (click)="openHelpChat(); $event.stopPropagation()">
                    <mat-icon
                        class="fuse-vertical-navigation-item-icon text-gray-900 group-hover:fill-[#0061ff]"
                        [ngClass]="'icon-size-6'"
                        [svgIcon]="'mat_solid:help_outline'"></mat-icon>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title">
                            <span class="ml-2 m-auto font-medium text-[14px] group-hover:text-[#0061ff]">Ajuda</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="px-4 py-2">
                <div class="pointer-events-auto flex m-auto px-3 py-2 cursor-pointer text-gray-900 group hover:rounded-xl hover:bg-[#eff7ff] fuse-vertical-navigation-item-wrapper font-inter"
                     (click)="signOut()">
                    <mat-icon
                        class="fuse-vertical-navigation-item-icon text-gray-900 group-hover:fill-[#0061ff]"
                        [ngClass]="'icon-size-6'"
                        [svgIcon]="'mat_solid:logout'"></mat-icon>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title">
                            <span class="ml-2 m-auto font-medium text-[14px] group-hover:text-[#0061ff]">Sair</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-menu>
